var _rect, _rect2, _path, _path2, _circle, _ellipse, _path3, _path4, _path5, _path6;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgStructureLogo = function SvgStructureLogo(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.4167,
    y: 71.3066,
    width: 16.6667,
    height: 16.6667,
    rx: 2,
    fill: "#EAEFFE",
    stroke: "#2B64F5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 72.9167,
    y: 71.3066,
    width: 16.6667,
    height: 16.6667,
    rx: 2,
    fill: "#EAEFFE",
    stroke: "#2B64F5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 50.4727H27.0833C22.481 50.4727 18.75 54.2036 18.75 58.806V71.306",
    stroke: "#2B64F5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6667 50.4727H72.9167C77.5191 50.4727 81.2501 54.2036 81.2501 58.806V71.306",
    stroke: "#2B64F5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.0001,
    cy: 79.64,
    r: 8.33333,
    fill: "#EAEFFE",
    stroke: "#2B64F5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.0001,
    cy: 21.306,
    rx: 8.33333,
    ry: 8.33333,
    fill: "#EAEFFE",
    stroke: "#2B64F5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0001 71.3053V67.1387",
    stroke: "#2B64F5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0001 29.6387V33.8053",
    stroke: "#2B64F5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0031 44.2227L49.997 56.7227",
    stroke: "#2B64F5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 50.4689L56.25 50.4751",
    stroke: "#2B64F5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStructureLogo, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };